import { Flex } from '@chakra-ui/layout'
import { Button, Input, InputGroup, InputLeftAddon } from '@chakra-ui/react'
import { Select } from '@chakra-ui/select'
import React from 'react'
import { useForm } from 'react-hook-form'

export function Filtro({ resultado, getNotasValidadas }) {
  const { register, handleSubmit, formState } = useForm()

  async function onSubmit(filter) {
    console.log(filter)
    await resultado(filter)
  }

  return (
    <Flex
      paddingInline={'2rem'}
      marginBlock={'2rem'}
      flexDir={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      gap={5}
      as={'form'}
      onSubmit={handleSubmit(onSubmit)}
    >
      <Flex gap={2}>
        <InputGroup>
          <InputLeftAddon children="N. Pedido" />
          <Input
            type={'number'}
            placeholder={'Pedido'}
            {...register('pedido')}
          />
        </InputGroup>

        <Button
          bgColor={'#378BBF'}
          width={'200px'}
          color={'white'}
          type={'submit'}
          _hover={{
            filter: 'brightness(0.8)',
          }}
          isLoading={formState.isSubmitting}
        >
          Filtrar
        </Button>

        <Button
          bgColor={'#378BBF'}
          width={'200px'}
          color={'white'}
          type={'button'}
          _hover={{
            filter: 'brightness(0.8)',
          }}
          onClick={getNotasValidadas}
        >
          Notas validadas
        </Button>
      </Flex>
    </Flex>
  )
}
